module.exports = __webpack_public_path__ + "static/media/tennis.2bcce9fc.jpg";